import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import EmpowerMarketersPng2x from './assets/EmpowerMarketers@2x.png'
import EmpowerMarketersWebp from './assets/EmpowerMarketers.webp'
import EmpowerMarketersWebp2x from './assets/EmpowerMarketers@2x.webp'

const EmpowerMarketersImage = () => {
  return (
    <Picture>
      <source type="image/webp" srcSet={`${EmpowerMarketersWebp}, ${EmpowerMarketersWebp2x} 2x`} />
      <StyledImage
        width="828"
        height="717"
        src={EmpowerMarketersPng2x}
        alt="Illustration: Empower marketers with the data they need"
        loading="lazy"
      />
    </Picture>
  )
}

const StyledImage = styled(Image)`
  width: 100%;
  max-width: 600px;
`

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

export default EmpowerMarketersImage
